const getPrice = (item, type, prices, sizeId) => {
    const priceTable = type === 'menu' ? prices.servicePrices : prices.optionPrices;
    // 가격 정보나 사이즈 ID가 없으면 0을 반환하여 오류를 방지합니다.
    if (!priceTable || !sizeId) return 0; 
    
    const priceEntry = priceTable.find(p => 
        p[type === 'menu' ? 'menu_id' : 'option_id'] === item.id && 
        p.size_id === parseInt(sizeId)
    );
    // 해당하는 가격 설정이 없으면 0을 반환합니다.
    return priceEntry ? parseFloat(priceEntry.price) : 0; 
};

export const calculatePrices = ({ selectedMenu, selectedOptions, prices, sizeId, adjustmentAmount }) => {
    let calculated = 0;
    
    if (selectedMenu) {
        calculated += getPrice(selectedMenu, 'menu', prices, sizeId);
    }

    if (selectedOptions) {
        selectedOptions.forEach(option => {
            calculated += getPrice(option, 'option', prices, sizeId);
        });
    }

    const adjustment = parseFloat(adjustmentAmount) || 0;
    const total = calculated + adjustment;

    return {
        calculatedPrice: calculated,
        totalPrice: total,
    };
};
